var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "grm-snackbar",
      class: [
        _vm.grmSnackbarClass,
        "p-4 rounded-lg flex items-start absolute overflow-hidden transition-all duration-300 pointer-events-auto",
      ],
      style: _vm.grmSnackbarStyle,
      attrs: { "data-snackbar-id": _vm.snackbar.id },
      on: { click: _vm.showAllMessage },
    },
    [
      _c("div", {
        ref: "duration",
        staticClass: "w-full h-0.5 absolute top-0 right-0 left-0",
        class: _vm.durationClass,
        style: _vm.durationStyle,
      }),
      !_vm.snackbar.hideIcon
        ? _c(
            "div",
            { staticClass: "h-6 mr-2 flex items-center" },
            [
              _c("GrmIcon", {
                class: [_vm.isShowAllMessage ? "self-baseline mt-px" : ""],
                attrs: { icon: _vm.snackbar.type },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("span", { staticClass: "sr-only" }, [
        _vm._v(_vm._s(_vm.snackbar.type)),
      ]),
      _c("p", {
        ref: "message",
        class: [
          _vm.messageClass,
          { "whitespace-normal": _vm.isShowAllMessage },
          "min-w-0 text-sm leading-6 font-medium flex items-center flex-1 w-min truncate",
        ],
        domProps: { innerHTML: _vm._s(_vm.snackbar.message) },
      }),
      _c("GrmCloseBtn", {
        staticClass: "ml-1",
        class: [_vm.closeBtnClass, { "self-baseline": _vm.isShowAllMessage }],
        attrs: { notShowTooltip: "", color: _vm.snackbar.type },
        on: { click: _vm.close },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }